import React, { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import ReactPlayer from "react-player";
import { Col, Row, Select, Tabs } from "antd";
import { useTranslation } from "react-i18next";
import { Translate } from "react-auto-translate";
import { useDispatch } from "react-redux";
import Cookies from "js-cookie";
import { useLocation } from "react-router-dom";
import { useHistory } from "react-router-dom";

import moment from "moment";
import { TIME_FORMAT } from "../../settings/formatDateTime";
import {
  URL_API_LIBRARY_HOME,
  GET_LIST_CATEGORY,
  URL_API_LIBRARY,
  URL_VIEW_LIBRARY,
} from "../../utils/constants";
import { setHiddenHeader } from "../../actions";
import { changeLanguage, getMediaUrl } from "../../utils/functions";
import { postData, getTakenData, getDataByID } from "../../utils/service";
import ModalGallery from "../../components/ModalGallery";
import PaginationCustom from "../../components/pagination";

import iconPlay from "../../assets/images/icons/play_button.svg";
import defaultBanner from "./../../assets/images/default_image.svg";
import {
  CardGridSkeleton,
  LibraryGridSkeleton,
} from "../../components/HomeSkeletons";
import FallbackImage from "../../components/FallbackImage";
import LibraryMediaTile from "../../components/LibraryMediaTile";

const { TabPane } = Tabs;

const SectionLibrary = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const beginQuery = location?.search?.split("?")?.[1];

  const [query, setQuery] = useState(beginQuery);
  const [dataBook, setDataBook] = useState([]);
  const [paginateBook, setPaginateBook] = useState({});

  const [dataImage, setDataImage] = useState([]);
  const [paginateImage, setPaginateImage] = useState({});

  const [dataVideo, setDataVideo] = useState([]);
  const [paginateVideo, setPaginateVideo] = useState({});

  const [dataTypeDocument, setDataTypeDocument] = useState([]);
  const [paginateDocument, setPaginateDocument] = useState({});

  const [categoryOption, setCategoryOption] = useState([]);
  const [filterCategory, setFilterCategory] = useState(0);
  const [loadingImage, setLoadingImage] = useState(true);
  const [loadingVideo, setLoadingVideo] = useState(true);
  const [loadingBook, setLoadingBook] = useState(true);
  const [loadingDocument, setLoadingDocument] = useState(true);

  const [modalGallery, setModalGallery] = useState({
    visible: false,
    data: [],
  });

  useEffect(() => {
    getTakenData(GET_LIST_CATEGORY).then((res) => {
      setCategoryOption([
        {
          value: 0,
          label: "Tất cả",
        },
        ...res?.data?.map((item) => ({
          value: item?.id,
          label: item?.title,
        })),
      ]);
    });
  }, []);

  const fetchDocument = useCallback(
    (pages = 1) => {
      setLoadingDocument(true);
      const payload = {
        category_id: filterCategory,
        page: pages,
        per_page: 8,
        keyword: "",
        catalog_id: 5,
      };
      try {
        postData(URL_API_LIBRARY, payload)
          .then((res) => {
            const resData = [...res?.data?.data]?.sort((a, b) => {
              return new Date(b?.updated_at) - new Date(a?.updated_at);
            });
            setDataTypeDocument(resData);
            setPaginateDocument(res?.data?.paginate);
          })
          .catch(() => {
            setDataTypeDocument([]);
          })
          .finally(() => {
            setLoadingDocument(false);
          });
      } catch (error) {
        setDataTypeDocument([]);
        setLoadingDocument(false);
      }
    },
    [filterCategory]
  );

  const fetchBook = useCallback(
    (pageBook = 1) => {
      setLoadingBook(true);
      try {
        postData(URL_API_LIBRARY_HOME, {
          per_page: 8,
          catalog_id: 3,
          page: pageBook,
          category_id: filterCategory,
        })
          .then((res) => {
            setDataBook(res?.data?.data);
            setPaginateBook(res?.data?.paginate);
          })
          .catch(() => {
            setDataBook([]);
          })
          .finally(() => {
            setLoadingBook(false);
          });
      } catch (error) {
        setDataBook([]);
        setLoadingBook(false);
      }
    },
    [filterCategory]
  );

  const fetchImage = useCallback(
    (pageImage = 1) => {
      setLoadingImage(true);
      try {
        postData(URL_API_LIBRARY_HOME, {
          per_page: 8,
          catalog_id: 4,
          page: pageImage,
          category_id: filterCategory,
        })
          .then((res) => {
            setDataImage(res?.data?.data);
            setPaginateImage(res?.data?.paginate);
          })
          .catch(() => {
            setDataImage([]);
          })
          .finally(() => {
            setLoadingImage(false);
          });
      } catch (error) {
        setDataImage([]);
        setLoadingImage(false);
      }
    },
    [filterCategory]
  );

  const fetchVideo = useCallback(
    (pageVideo = 1) => {
      setLoadingVideo(true);
      try {
        postData(URL_API_LIBRARY_HOME, {
          per_page: 8,
          catalog_id: 1,
          page: pageVideo,
          category_id: filterCategory,
        })
          .then((res) => {
            setDataVideo(res?.data?.data);
            setPaginateVideo(res?.data?.paginate);
          })
          .catch(() => {
            setDataVideo([]);
          })
          .finally(() => {
            setLoadingVideo(false);
          });
      } catch (error) {
        setDataVideo([]);
        setLoadingVideo(false);
      }
    },
    [filterCategory]
  );

  useEffect(() => {
    fetchBook();
    fetchImage();
    fetchVideo();
    fetchDocument();
  }, [fetchBook, fetchDocument, fetchImage, fetchVideo]);

  const onChangePaginationBook = (page) => {
    fetchBook(page);
  };
  const onChangePaginationDocument = (page) => {
    fetchDocument(page);
  };

  const onChangePaginationImage = (page) => {
    const yOffset = -75;
    const element = document.getElementById("section-library");
    const y =
      element.getBoundingClientRect().top + window.pageYOffset + yOffset;
    window.scrollTo({ top: y, behavior: "smooth" });
    fetchImage(page);
  };

  const onChangePaginationVideo = (page) => {
    const yOffset = -75;
    const element = document.getElementById("section-library");
    const y =
      element.getBoundingClientRect().top + window.pageYOffset + yOffset;
    window.scrollTo({ top: y, behavior: "smooth" });
    fetchVideo(page);
  };

  const closeModalGallery = () => {
    setModalGallery({
      visible: false,
      data: [],
    });
    dispatch(setHiddenHeader(false));
  };

  const handleGallery = (gallery) => {
    setModalGallery({
      visible: true,
      data: gallery,
    });
  };
  const handleHideHeader = (id) => {
    getDataByID(URL_VIEW_LIBRARY, id);
    dispatch(setHiddenHeader(true));
  };

  const handleView = (id) => {
    getDataByID(URL_VIEW_LIBRARY, id);
  };

  const handleFilterCategory = (type) => {
    setFilterCategory(type);
    setTimeout(() => {
      const gglang = Cookies.get("googtrans");
      changeLanguage(gglang ? gglang.replace("/vi/", "") : "vi");
    }, 500);
  };

  const handleTabChange = (key) => {
    setQuery(key);
    if (location.pathname === "/document") {
      history.push(`${location.pathname}?${key}`);
    }
  };

  useEffect(() => {
    if (location.pathname === "/document") {
      setQuery(beginQuery || "1");
    }
  }, [location?.search, beginQuery, location.pathname]);

  const getFileUrl = (...paths) => getMediaUrl(...paths) || "#";
  return (
    // <Translator
    //   from="vi"
    //   to={localStorage.getItem("to")}
    //   googleApiKey="AIzaSyCMV_XCGZjgDZ-sEB5zZir1fxAluZMBelc"
    // >
    <section className="section-library-home" id="section-library">
      {modalGallery.visible ? (
        <ModalGallery
          visible={modalGallery.visible}
          gallery={modalGallery.data}
          closeModal={closeModalGallery}
        />
      ) : null}

      <div className="block-title-main">
        <div className="block-title-main__title">
          <p className="block-title-main__title-library">
            <Translate>{t("home-page.title-library")}</Translate>
          </p>
        </div>

        <div className="block-tab-library">
          <Select
            options={categoryOption}
            onChange={handleFilterCategory}
            className="library-filter-wrap"
            defaultValue={filterCategory}
          />
          <Tabs onChange={handleTabChange} activeKey={query || "1"}>
            <TabPane
              tab={
                <span className="tab-title-text">
                  <Translate>{t("home-page.title-child-image")}</Translate>
                </span>
              }
              key="1"
            >
              {loadingImage ? (
                <LibraryGridSkeleton count={8} />
              ) : (
                <div className="content-main content-main-image row">
                  {dataImage?.map((item, index) => {
                  return (
                    <div
                      key={index}
                      className="col-12 col-sm-6	col-md-4 col-xl-3 "
                      onClick={() => handleHideHeader(item?.id)}
                    >
                      <LibraryMediaTile
                        onClick={() => handleGallery(item?.attach_files)}
                        paths={[item?.attach_files?.[0]?.url]}
                      >
                        <div className="bg-gradient"></div>
                        <div className="title-img">
                          <span className="label content-custom">
                            {t("home-page.title-child-image")}
                          </span>
                          <p className="content-custom">{item?.title}</p>
                        </div>
                      </LibraryMediaTile>
                    </div>
                  );
                })}
                </div>
              )}

              {!loadingImage && paginateImage?.total > 8 && (
                <PaginationCustom
                  className="pagination-home-page"
                  current={paginateImage?.current_page}
                  pageSize={8}
                  onChange={onChangePaginationImage}
                  total={paginateImage?.total}
                />
              )}
            </TabPane>
            <TabPane
              tab={
                <span className="tab-title-text">
                  {t("home-page.title-child-video")}
                </span>
              }
              key="2"
            >
              {loadingVideo ? (
                <LibraryGridSkeleton count={8} />
              ) : (
                <div className="content-main  content-main-video row">
                  {dataVideo?.map((item, index) => {
                  return (
                    <div
                      key={index}
                      className="col-12 col-sm-6	col-md-4 col-xl-3  videoPlayerLibrary"
                    >
                      <LibraryMediaTile
                        className="content-main-video__item"
                        paths={[item?.thumbnail]}
                      >
                        {!item?.url_video && item?.attach_files?.length > 0 && (
                          <video
                            className="item-video"
                            controls
                            id={`item-video-${item?.id}`}
                            style={{ display: "none" }}
                            key={item?.id}
                          >
                            <source
                              src={getMediaUrl(item?.attach_files?.[0]?.url)}
                              type="video/mp4"
                            />
                          </video>
                        )}

                        <div className="bg-gradient"></div>
                        {!item?.url_video ? (
                          <a
                            data-fancybox
                            href={`#item-video-${item?.id}`}
                            onClick={() => handleView(item?.id)}
                          >
                            <img className="icon-play" src={iconPlay} alt="" />
                          </a>
                        ) : (
                          <a
                            data-fancybox
                            href={item?.url_video}
                            onClick={() => handleView(item?.id)}
                          >
                            <img className="icon-play" src={iconPlay} alt="" />
                          </a>
                        )}

                        <div className="title-video">
                          <span className="label content-custom">
                            {t("home-page.title-child-video")}
                          </span>
                          <p className="content-custom">{item?.title}</p>
                        </div>
                      </LibraryMediaTile>
                    </div>
                  );
                })}
                </div>
              )}

              {!loadingVideo && paginateVideo?.total > 4 && (
                <PaginationCustom
                  className="pagination-home-page"
                  current={paginateVideo?.current_page}
                  pageSize={8}
                  onChange={onChangePaginationVideo}
                  total={paginateVideo?.total}
                />
              )}
            </TabPane>
            <TabPane
              tab={
                <span className="tab-title-text">
                  <Translate>{t("home-page.title-child-book")}</Translate>
                </span>
              }
              key="3"
            >
              {loadingBook ? (
                <LibraryGridSkeleton count={8} />
              ) : (
                <div className="content-main content-main-image row">
                  {dataBook?.map((item, index) => {
                  return (
                    <div
                      key={index}
                      className="col-12 col-sm-6 col-md-4 col-xl-3"
                    >
                      <a
                        href={getFileUrl(item?.attach_files?.[0]?.url)}
                        target="__blank bl"
                        onClick={() => handleView(item?.id)}
                      >
                        <LibraryMediaTile paths={[item?.bgr_image]}>
                          <div className="bg-gradient"></div>
                          <div className="title-img">
                            <span className="label content-custom">
                              {t("home-page.title-child-book")}
                            </span>
                            <p className="content-custom">{item?.title}</p>
                          </div>
                        </LibraryMediaTile>
                      </a>
                    </div>
                  );
                })}
                </div>
              )}
              {!loadingBook && paginateBook?.total > 8 && (
                <PaginationCustom
                  className="pagination-home-page"
                  current={paginateBook?.current_page}
                  pageSize={8}
                  onChange={onChangePaginationBook}
                  total={paginateBook?.total}
                />
              )}
            </TabPane>
            <TabPane
              tab={
                <span className="tab-title-text">
                  <Translate>{t("home-page.title-child-document")}</Translate>
                </span>
              }
              key="4"
            >
              {loadingDocument ? (
                <CardGridSkeleton
                  count={8}
                  colProps={{ xs: 24, sm: 12, md: 12, lg: 8, xl: 6 }}
                  variant="imageTitle"
                />
              ) : (
                <div className="content-main content-main-document row">
                  {dataTypeDocument?.map((item) => {
                  return (
                    <div
                      key={item?.id}
                      className="col-12 col-sm-6	col-md-6 col-lg-4 col-xl-3"
                    >
                      <div className="block-item-activity__content block-item-activity__content__document ">
                        <div
                          className="block-item-activity__content--image"
                          onClick={() =>
                            history.push(
                              `/document/${filterCategory}/detail/${item?.id}`
                            )
                          }
                        >
                          <FallbackImage
                            variant="fill"
                            paths={[item?.banner]}
                            fallback={defaultBanner}
                            alt={item?.title || ""}
                          />
                        </div>

                        <Link
                          to={`/document/${filterCategory}/detail/${item?.id}`}
                        >
                          <Translate>{item?.title}</Translate>
                        </Link>
                        <div className="block-item-activity__content--date">
                          <hr />
                          <p>
                            {moment(item?.updated_at, "YYYY-MM-DD").format(
                              TIME_FORMAT.DOT_DATE_FORMAT
                            )}
                          </p>
                        </div>
                      </div>
                    </div>
                  );
                })}
                </div>
              )}

              {!loadingDocument && paginateDocument?.total > 8 && (
                <PaginationCustom
                  className="pagination-home-page"
                  current={paginateDocument?.current_page}
                  pageSize={8}
                  onChange={onChangePaginationDocument}
                  total={paginateDocument?.total}
                />
              )}
            </TabPane>
          </Tabs>
        </div>
      </div>
    </section>
    // </Translator>
  );
};

export default SectionLibrary;
